import { render, staticRenderFns } from "./v80o1020BomPop.vue?vue&type=template&id=4252979d&scoped=true"
import script from "./v80o1020BomPop.vue?vue&type=script&lang=js"
export * from "./v80o1020BomPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4252979d",
  null
  
)

export default component.exports